import { CallbackHolder } from "abweb/utils/callback/CallbackHolder";
/**
 * Support invoking 0-arg predicate (returns boolean) listeners
 */
export class Callback0ArgPredicate extends CallbackHolder {
  /**
   * @returns {boolean} returns false iff any listener returns false.
   * Invokes all listeners (does NOT short-circuit)
   */
  callAll() {
    let ret = true;
    for (let listener of this.getCallbacks()) {
      ret = listener() && ret;
    }
    return ret;
  }

  /**
   * @return {boolean} true iff any listener returns true.  Short-circuits on first true,
   * and if there are no listeners at all it returns false.
   */
  callUntilFirstTrue() {
    for (let listener of this.getCallbacks()) {
      if (listener()) {
        return true;
      }
    }
    return false;
  }

  /**
   * @return {boolean} false iff any listener returns false.  Short-circuits on first false,
   * and if there are no listeners at all it returns true.
   */
  callUntilFirstFalse() {
    for (let listener of this.getCallbacks()) {
      if (!listener()) {
        return false;
      }
    }
    return true;
  }
}
//# sourceMappingURL=Callback0ArgPredicate.js.map
